import { useEffect, useState } from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { CatalogApi, catalogApiRef } from '@backstage/plugin-catalog-react';

interface GroupOption {
  value: string;
  label: string;
}

const useRelatedGroupPicker: (
  systemRef: string,
  projectRefs: string[],
  formData: string[],
  onChange: React.Dispatch<React.SetStateAction<string[]>>,
) => { options: GroupOption[] } = (
  systemRef: string,
  projectRefs: string[],
  formData: string[],
  onChange: React.Dispatch<React.SetStateAction<string[]>>,
) => {

    const catalogApi: CatalogApi = useApi(catalogApiRef);
    const [options, setOptions] = useState<GroupOption[]>([]);
    const [projectsOwner, setProjectsOwner] = useState<string[]>([]);

    useEffect(() => {
      async function fetchProjects() {
        const owners: string[] = [];

        for (const ref of projectRefs) {
          const project = await catalogApi.getEntities({
            filter: {
              kind: 'Component',
              'metadata.name': ref,
            },
          });

          project.items.forEach(item => {
            const owner = item.spec?.owner;
            if (owner) {
              owners.push(owner as string)
            }
          });
        }

        setProjectsOwner(owners);
      }

      fetchProjects();
    }, [catalogApi, projectRefs]);

    useEffect(() => {
      async function fetchGroups() {
        if (!systemRef) {
          setOptions([]);
          return;
        }

        try {
          const system = await catalogApi.getEntityByRef(systemRef);
          if (!system) {
            setOptions([]);
            return;
          }

          const owner = await catalogApi.getEntities({
            filter: {
              kind: 'Group',
              'metadata.name': system.metadata.name,
            },
          });

          const groups = new Set<string>();

          owner.items.forEach(item => {
            const children = item.spec?.children;
            if (Array.isArray(children)) {
              children.forEach(child => {
                groups.add(child as string);
              });
            }
          });

          const groupOptions: GroupOption[] = Array.from(groups).map(
            group => ({
              value: group,
              label: group,
            }),
          );

          setOptions(groupOptions);
        } catch (error) {
          setOptions([]);
        }
      }

      fetchGroups();
    }, [catalogApi, systemRef]);

    useEffect(() => {
      if ((!formData || formData.length === 0) && projectsOwner.length > 0) {
        onChange([...projectsOwner]);
      }
    }, [formData, projectsOwner, onChange]);


    return { options };
  }

export default useRelatedGroupPicker;